/******************************************************************************************
 *	Invite Reseller Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.licenseAdminInviteReseller', []).controller(
    'LicenseAdminInviteResellerController',
    /* @ngInject */
    function(
      _,
      $log,
      $rootScope,
      $scope,
      $filter,
      $state,
      RESELLER_PREFERRED_LANGUAGES,
      Settings,
      CurtainNotifications,
      CountryList,
      feature,
      Regions,
      Resellers
    ) {
      //Expose RESELLER_PREFERRED_LANGUAGES to view
      $scope.preferredLanguages = RESELLER_PREFERRED_LANGUAGES;

      function removeFirstCharIfInvalid(value) {
        const arr =  _.split(value, '');
        if (/[!+=/\-@|]/.test(arr[0])) {
          return value.slice(1);
        }
        return value;
      }

      $scope.zipCodeChange = function () {
        $scope.zipCode = removeFirstCharIfInvalid($scope.zipCode);
      };

      //Get countries
      var currentCountryCode; //Stores country code before language switch
      var fetchCountries = function() {
        $scope.loadingCountries = true;
        CountryList.get()
          .$promise.then(function(countryList) {
            $scope.loadingCountries = false;

            if (feature.isEnabled('temp_disable_for_belarus')) {
              $scope.countries = $filter('filter')(countryList.items, {countryCode: '!BY'}, true);
            }

            if (feature.isEnabled('temp_disable_for_russia')) {
              $scope.countries = $filter('filter')($scope.countries, {countryCode: '!RU'}, true);
            }

            $scope.countries = _.orderBy($scope.countries, ['countryName']);

            //Restore previous selection if any
            if (currentCountryCode) {
              for (var i = 0, count = $scope.countries.length; i < count; i++) {
                if ($scope.countries[i].countryCode === currentCountryCode) {
                  $scope.country = $scope.countries[i];
                  currentCountryCode = null; //Single use
                  break;
                }
              }
            }
          })
          .catch(function(error) {
            $scope.loadingCountries = false;
            CurtainNotifications.show(
              CurtainNotifications.ERROR,
              'licenseAdminCreateReseller.notifications.noCountries'
            );
            $log.error('Failed to load country list', error);
          });
      };

      //Populate countries dropdown
      fetchCountries();

      //Get regions when country is selected
      var currentRegionCode; //Stores region code before language switch
      var fetchRegions = function() {
        if ($scope.country) {
          $scope.loadingRegions = true;
          Regions.get($scope.country.countryCode)
            .then(function(responseData) {
              $scope.loadingRegions = false;
              $scope.regions = responseData;

              //Restore previous selection if any
              if (currentRegionCode) {
                for (var i = 0, count = $scope.regions.length; i < count; i++) {
                  if ($scope.regions[i].regionCode === currentRegionCode) {
                    $scope.region = $scope.regions[i];
                    currentRegionCode = null; //Single use
                    break;
                  }
                }
              } else {
                $scope.region = $scope.regions[0]; //Set selected option
              }
            })
            .catch(function(response) {
              $scope.loadingRegions = false;

              if (response.status !== 0) {
                //Aborted calls can mean new region was requested, cancelling a prior request
                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'licenseAdminCreateReseller.notifications.noRegions'
                );
                $log.error('Failed to load regions', response.data);
              }
            });
        }
      };
      $scope.countrySelectionChange = fetchRegions;

      //Submit
      //Control vars for UI validation errors
      $scope.submitAttempted = false; //Was submit button clicked?

      var resetSubmit = function() {
        $scope.submitted = false;
        $scope.submitAttempted = false;
      };

      $scope.submit = function() {
        if (!$scope.submitted) {
          $scope.submitAttempted = true;

          if ($scope.inviteResellerForm.$valid) {
            $scope.submitted = true;

            var payload = {
              name: $scope.resellerName,
              externalSalesContractId: $scope.salesforceId,
              preferredLanguage: $scope.language,
              primaryAdmin: {
                first_name: $scope.firstName,
                email: $scope.email,
                last_name: $scope.lastName
              },
              address: {
                region: $scope.region,
                street1: $scope.street1,
                street2: $scope.street2,
                postalCode: $scope.zipCode,
                country: $scope.country,
                city: $scope.city
              }
            };

            Resellers.invite(payload)
              .then(function() {
                $scope.showSuccessOverlay = true;
              })
              .catch(function(response) {
                $log.error('Failed to invite reseller', response.data);

                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  //Get first character from HTTP status as number
                  var statusType = +('' + response.status).charAt(0);

                  if (statusType === 4) {
                    if (response.data && response.data.errorMessage === 'INVALID_EMAIL') {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'licenseAdminCreateReseller.notifications.invalidEmail'
                      );
                    } else {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                    }

                    resetSubmit();
                  } else if (response.status === 500) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                    resetSubmit();
                  }
                }
              });
          }
        }
      };

      //Navigation
      $scope.goBack = function() {
        $state.go('licenseAdmin.search');
      };
    }
  );
})();
